var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12ZM22.4 12C22.4 17.7438 17.7438 22.4 12 22.4C6.25624 22.4 1.6 17.7438 1.6 12C1.6 6.25624 6.25624 1.6 12 1.6C17.7438 1.6 22.4 6.25624 22.4 12ZM11.2 5.8V7.2C11.2 7.64183 11.5582 8 12 8C12.4418 8 12.8 7.64183 12.8 7.2V5.8C12.8 5.35817 12.4418 5 12 5C11.5582 5 11.2 5.35817 11.2 5.8ZM11.2 9.8V18.2C11.2 18.6418 11.5582 19 12 19C12.4418 19 12.8 18.6418 12.8 18.2V9.8C12.8 9.35817 12.4418 9 12 9C11.5582 9 11.2 9.35817 11.2 9.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlue);
export default __webpack_public_path__ + "static/media/warning-blue.bc2791bf0a2d0c8b189cb17d650966d4.svg";
export { ForwardRef as ReactComponent };